export default __webpack_public_path__ + "static/media/arrow_dropdown_white.51a28be4.svg";